import { render, staticRenderFns } from "./table-action-footer.vue?vue&type=template&id=34396282&"
import script from "./table-action-footer.vue?vue&type=script&lang=js&"
export * from "./table-action-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports